import { ConditionalRebatesStatus } from "src/store/reducers/conditionalRebates";
import { ConditionalRebateState } from "Types/state";

export const requestStarted = (state: ConditionalRebateState) => {
    return {
        status: ConditionalRebatesStatus.Loading,
        requests: state.requests + 1,
    };
};

export const requestFinished = (state: ConditionalRebateState) => {
    return {
        status: state.requests === 1 ? ConditionalRebatesStatus.Idle : state.status,
        requests: state.requests - 1,
    };
};
